import React from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { TshirtAddIcon } from '@depop/web-ui-kit/Icons/TshirtAddIcon';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';
import { RepopTile } from '@/components/RepopTile';
import { type Receipt } from '@/modules/receipts/types.ts';

type Props = {
  products: Receipt.Receipt[];
};

export function RepopEmptyState({ products }: Props) {
  const tShop = useTranslations('shop');
  const tSellerHub = useTranslations('sellerhub');

  const hasRepopProducts = products.length > 0;

  return (
    <div
      className={clsx(styles.container, {
        [styles['container-repop']]: hasRepopProducts,
      })}
    >
      <TshirtAddIcon size={34} />
      <Body variant="sm-regular" className={styles.iconText}>
        {tShop('EmptyState.NoProducts')}
      </Body>
      <div className={styles.ctaButtonWrapper}>
        <ExtendedLink href="/products/create?cta=ShopEmptyState.NewListing">
          <ButtonExperiment size="regular" as="span">
            {tSellerHub('Layout.Button.ListAnItem')}
          </ButtonExperiment>
        </ExtendedLink>
      </div>
      {hasRepopProducts && (
        <>
          <Heading variant="md" className={styles.title}>
            {tShop('Repop.Title')}
          </Heading>
          <Body variant="sm-regular" className={styles.description}>
            {tShop('Repop.Description')}
          </Body>
          <div className={styles.receiptsWrapper}>
            {products.map((product) => (
              <RepopTile key={product.purchaseId} {...product} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
